// src/api/auth.js

const API_URL = process.env.REACT_APP_API_URL;

export const login = async (username, password) => {
  const res = await fetch(`${API_URL}/login`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',   // recibe la cookie de /api/uploads
    body: JSON.stringify({ username, password })
  });

  const data = await res.json();

  if (!res.ok) throw new Error(data.error || 'Credenciales inválidas');

  // Guardar tokens en localStorage
  localStorage.setItem('token', data.token);
  localStorage.setItem('usuario', JSON.stringify(data.user));
  if (data.refreshToken) {
    localStorage.setItem('refreshToken', data.refreshToken);
  }

  return { token: data.token, user: data.user, refreshToken: data.refreshToken };
};

// En api/authApi.js
export const logout = async () => {
  try {
    const token = localStorage.getItem('token');
    const usuario = JSON.parse(localStorage.getItem('usuario') || '{}');
    
    const response = await fetch(`${process.env.REACT_APP_API_URL}/logout`, {
      method: 'POST',
      credentials: 'include',   // para que el backend borre la cookie de archivos
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        sessionId: usuario.sessionId, // 🆕 Enviar sessionId
        // El backend cierra solo la sesion de este dispositivo
        refreshToken: localStorage.getItem('refreshToken') || undefined,
      })
    });

    return response.json();
  } catch (error) {
    console.error('Error en logout API:', error);
    throw error;
  }
};

export async function forgotPassword(email) {
  const res = await fetch(`${API_URL}/auth/forgot-password`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email })
  });
  return res.json();
}

export async function resetPassword({ email, token, password }) {
  const res = await fetch(`${API_URL}/auth/reset-password`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email, token, password })
  });
  return res.json();
}